import { render } from "./CreateDemand.page.vue?vue&type=template&id=17b4b2ec"
import script from "./CreateDemand.page.vue?vue&type=script&lang=js"
export * from "./CreateDemand.page.vue?vue&type=script&lang=js"

import "./CreateDemand.page.vue?vue&type=style&index=0&id=17b4b2ec&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QHeader from 'quasar/src/components/header/QHeader.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPageContainer,QPage,QHeader,QToolbar,QToolbarTitle});
